import Button from "@mui/material/Button";
import OutlinedInput from "@mui/material/OutlinedInput";
import { useFundraiser } from "../../pages/ImprovedShopPage/FundraiserContext";
import { useState } from "react";
import AddToCartButton from "../Storefront/AddToCartButton";
import { CartItem, generateUniqueId } from "../../Interfaces/Types";
import {
  FundraiserParticipantShop,
  ImprovedParticipantShop,
} from "../../Interfaces/FundraiserRole";
import donationImage from "../../images/donation_box.png";
import config from "../../config";

interface DonationProps {
  participantShop: ImprovedParticipantShop;
  isFromSamplePage?: boolean;
}

const Donation: React.FC<DonationProps> = ({
  participantShop,
  isFromSamplePage = false,
}) => {
  const [donation, setDonation] = useState<number>(0);
  const donationOptions = [25, 50, 75, 100, 150, 200];
  const donationMinimum: number = 5;
  const donation_item: CartItem = {
    id: generateUniqueId(),
    sku: config.DONATION_ITEM_ID,
    name: "Contribution",
    price: Number(donation),
    quantity: 1,
    image: donationImage,
  };
  const isDonationValid = donation && donation >= donationMinimum;

  const handleDonationClick = (amount: number) => {
    setDonation(amount);
  };

  const handleCustomAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const regex = /^(\d*\.?\d{0,2})$/;
    if (regex.test(value)) {
      setDonation(parseFloat(e.target.value));
    }
  };

  if (!participantShop) {
    return (
      <section className="donation-bg">
        <div className="mx-auto px-3 py-5 sec-wrapper">
          <div className="text-center">
            <p className="h4 text-primary-custom">
              Loading contribution data...
            </p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="donation-bg">
      <div className="mx-auto px-3 py-5 py-lg-5 sec-wrapper">
        <div className="row">
          <div className="col-12 col-md-1"></div>
          <div className="col-12 col-md-10">
            <div className="row g-4">
              <div className="col-12 col-lg-6 d-flex flex-column justify-content-center gap-4">
                <h1 className="fw-bold text-center text-lg-start font-fraunces text-primary-custom donation-heading">
                  <span className="text-dark-custom">Just Want</span>{" "}
                  <br className="d-none d-md-block" />
                  to Help?
                </h1>
                <p className="fs-6 fs-md-2 fw-light text-center text-lg-start">
                  Even if you're not shopping today, your support means the
                  world to us. Make a contribution to{" "}
                  {participantShop.fundraiser.org_name}!
                </p>
              </div>
              <div className="col-12 col-lg-6">
                <div className="border rounded-4 p-4 bg-white d-flex flex-column gap-4 border-primary-custom">
                  <div className="row g-2">
                    {donationOptions.map((amount) => (
                      <div key={amount} className="col-4 col-md-3 mb-3">
                        <Button
                          fullWidth
                          variant="outlined"
                          className="rounded-3 btn-custom-primary"
                          onClick={() => handleDonationClick(amount)}
                        >
                          ${amount}
                        </Button>
                      </div>
                    ))}
                  </div>

                  <div>
                    <p className="mb-2 fs-6">
                      Or Enter Custom Amount:{" "}
                      <span className="text-muted">
                        (minimum contribution is ${donationMinimum})
                      </span>
                    </p>
                    <input
                      type="number"
                      value={String(donation) || ""}
                      className="form-control bg-light border rounded-3 px-3 py-4 shadow-none"
                      placeholder="Enter amount"
                      onChange={handleCustomAmountChange}
                      style={{
                        backgroundColor: "#eaf3fb",
                        borderColor: "#bdbdbd",
                        fontSize: "1rem",
                        height: "40px",
                      }}
                    />
                  </div>
                  <AddToCartButton
                    item={donation_item}
                    participant={participantShop.participant}
                    buttonText="Add Contribution to Cart"
                    className="py-3 fs-6 text-nowrap text-capitalize rounded-3 font-jakarta"
                    disabled={!isDonationValid}
                    isFromSamplePage={isFromSamplePage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Donation;
